export const emptyMap = new Map();
